/* eslint-disable react/prop-types */
import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import {
  withAITracking,
  AppInsightsContext,
} from "@microsoft/applicationinsights-react-js";

import { initReactPlugin } from "../utils/initReactPlugin";
import { initAppInsights } from "../utils/initAppInsights";

const plugin = initReactPlugin();
const initAIWithPluginFn = initAppInsights(plugin);

interface Props extends RouteComponentProps<Props> {
  iKey: string;
} 

interface State {
  initialized: boolean;
}

class TelemetryProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { initialized: false };
  }

  componentDidMount() {
    this.initAI();
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.iKey !== prevProps.iKey) this.initAI();
  }

  initAI = () => {
    const { history } = this.props;
    const { iKey } = this.props;
    const { initialized } = this.state;

    if (!initialized && iKey && history) {
      try {
        initAIWithPluginFn(iKey, history);
        this.setState({ initialized: true });
      } catch (err) {
        console.error(err.message);
      }
    }
  };

  render() {
    return (
      <AppInsightsContext.Provider value={plugin}>
        {this.props.children}
      </AppInsightsContext.Provider>
    );
  }
}

// Add react app insights to component
const AIComponent = withAITracking(
  plugin,
  TelemetryProvider,
  "TelemetryProvider"
);

// Add redux iKey to component
const ConnectedComponent = connect((state: any) => {
  return {
    iKey: state.applicationSettingsReducer.iKey,
  };
})(AIComponent);

// Add router and export
export default withRouter(ConnectedComponent);



// WEBPACK FOOTER //
// ./src/appInsights/components/TelemetryProvider.tsx